"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class BecropPlan {
    constructor(becrop_plan_config) {
        this.type = becrop_plan_config.type;
        this.pricePerExtension = becrop_plan_config.pricePerExtension;
        this.unitPrice = becrop_plan_config.unitPrice || '$';
    }
}
exports.default = BecropPlan;
